/** @jsx jsx */

import { IconButton } from '@zapier/design-system';
import { jsx } from '@emotion/core';

type Props = {
  ariaLabel?: string;
  onDismiss: () => void;
};

const Dismiss = ({ onDismiss, ariaLabel = 'Close' }: Props) => (
  <IconButton aria-label={ariaLabel} icon="formX" onClick={onDismiss} />
);

export default Dismiss;
